module.exports = __webpack_public_path__ + "static/media/manual.c239fd7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/manual.jpg
// module id = 239
// module chunks = 0